import { FC } from "react"
import FacilityListItem from "./FacilityListItem"
import NewFacility from "../NewFacility"
import { isEditingAnotherRow } from "@/components/CustomersFacilitiesTable/utils"
import { Facility, FacilityForm } from "@/types/facility"

export const FacilityList: FC<{
   facilities: Facility[]
   editModeActiveRow: string
   deleteActiveRow: string
   creationMode: boolean
   createFacilityMode: boolean
   onEditModeChange: (id: string) => void
   onFacilityClick: (id: string) => void
   onAddUser: (id: string) => void
   onDelete: (facilityId: string, facilityName: string) => void
   onCreateFacility: () => void
   onSave: (facilityForm: FacilityForm) => void
   cancel: () => void
}> = ({
   facilities,
   editModeActiveRow,
   deleteActiveRow,
   creationMode,
   createFacilityMode,
   onFacilityClick,
   onAddUser,
   onEditModeChange,
   onCreateFacility,
   onSave,
   cancel,
   onDelete,
}) => {
   return (
      <>
         {facilities.map((facility, i) => (
            <FacilityListItem
               key={`${facility.id}-${i}`}
               isDisabledRow={
                  creationMode ||
                  isEditingAnotherRow(editModeActiveRow, facility.id)
               }
               facility={facility}
               editModeActiveRow={editModeActiveRow}
               onAddUser={onAddUser}
               onFacilityClick={onFacilityClick}
               onEditModeChange={onEditModeChange}
               onCreateFacility={onCreateFacility}
               deleteActiveRow={deleteActiveRow}
               onDelete={() => onDelete(facility.id, facility.name)}
            />
         ))}
         {createFacilityMode && (
            <NewFacility
               onSave={onSave}
               cancel={cancel}
            />
         )}
      </>
   )
}
